module.exports = __webpack_public_path__ + "img/2_189.e09cf96c.png";